import {
    createBrowserRouter,
    RouterProvider
} from 'react-router-dom';


import {Notifications} from '@mantine/notifications';
import {UserAttributesContextProvider} from "./context/UserAttributesContext.tsx";

import {ModalsProvider} from "@mantine/modals";

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-datatable/styles.css';
import '@flexinet/ui-components/style.css'

import {MantineProvider} from "@mantine/core";
import {AnalyticsAuthListener} from "@flexinet/analytics-components";
import {
    createAuthAwareQueryClient,
    SessionGuardProvider
} from "@flexinet/auth-components";
import {theme} from "./theme.ts";
import {AuthProvider} from "./context/AuthContext.tsx";
import {routesConfig} from "./config/routes.tsx";
import {PermissionsProvider} from "./providers/PermissionsProvider.tsx";
import {QueryClientProvider} from '@tanstack/react-query';

const queryClient = createAuthAwareQueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5,
            refetchOnWindowFocus: false,
        },
    },
});


// UserAccountProvider is deliberately absent (FNP-1119). The console reference
// mounts it between UserAttributesProvider and VerifiedPermissionsProvider, but
// there it feeds an `accounts` feature: the provider fetches a console Account
// via AccountsService and publishes it on UserAccountContext. This app has no
// accounts feature, no Account type, and nothing that reads account-level data —
// `account-settings` here is a single settings page, not an account entity.
// Adding the provider would mean inventing the entity it depends on, for no
// consumer. Revisit only when something actually needs the account record.
export const App = () => {

    const router = createBrowserRouter(routesConfig)

    return (
        <MantineProvider theme={theme}>
            <Notifications position={'bottom-left'}/>
            <SessionGuardProvider>
                <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                        <AnalyticsAuthListener/>
                        <UserAttributesContextProvider>
                            <PermissionsProvider>
                                <ModalsProvider>
                                    <RouterProvider router={router}/>
                                </ModalsProvider>
                            </PermissionsProvider>
                        </UserAttributesContextProvider>
                    </AuthProvider>
                </QueryClientProvider>
            </SessionGuardProvider>
        </MantineProvider>
    );
}
